import { useCallback, useEffect, useRef } from "react";

export function useScrollLock() {
    const scrollYRef = useRef<number>(0);

    const lockScroll = useCallback(() => {
        scrollYRef.current = window.scrollY;

        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollYRef.current}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
        document.body.style.overflow = "hidden";
        document.body.style.touchAction = "none";
    }, []);

    const unlockScroll = useCallback(() => {
        const scrollY = scrollYRef.current;

        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
        document.body.style.overflow = "";
        document.body.style.touchAction = "";

        window.scrollTo(0, scrollY);
    }, []);

    // Safety cleanup (component unmount)
    useEffect(() => {
        return () => {
            unlockScroll();
        };
    }, [unlockScroll]);

    return { lockScroll, unlockScroll };
}
